import { useEffect } from 'react'
import { authApi } from '@/lib/api'
import { useAuthStore } from '@/stores/auth-store'

interface AuthProviderProps {
  children: React.ReactNode
}

/**
 * Cek sesi aktif saat app dimuat dengan memanggil GET /auth/me.
 * Jika httpOnly cookie valid → user di-set di store.
 * Jika tidak ada sesi → user null (redirect ke login dilakukan oleh RequireAuth).
 * 10s fallback mencegah UI hang jika network lambat.
 */
export function AuthProvider({ children }: AuthProviderProps) {
  const setUser = useAuthStore((s) => s.setUser)
  const setInitialized = useAuthStore((s) => s.setInitialized)
  const initialized = useAuthStore((s) => s.initialized)

  useEffect(() => {
    const fallbackTimer = setTimeout(() => setInitialized(true), 10000)

    authApi
      .me()
      .then((user) => setUser(user))
      .catch(() => setUser(null))
      .finally(() => {
        clearTimeout(fallbackTimer)
        setInitialized(true)
      })

    return () => clearTimeout(fallbackTimer)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <p className="text-sm text-muted-foreground">Memuat...</p>
      </div>
    )
  }

  return <>{children}</>
}
